import React from 'react';
import { InputAdornment, DialogActions, Button, Grid, Typography } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs';
import {
  SingleInputDateRangeField,
  LocalizationProvider,
  DateRangePicker,
  PickersActionBarProps,
  DateRange,
} from '@mui/x-date-pickers-pro';
import dayjs from 'dayjs';

import CalendarIcon from 'assets/icons/buttons/date-picker.svg';
import ChevronIcon from 'assets/icons/chevron-left_new.svg';

import { shourtcutsItems } from './shortcuts';

import { styles } from './styles';

const ChevronRightIcon = () => <ChevronIcon className="rotated" />;

const CustomActionBar = ({ onAccept, onCancel }: PickersActionBarProps) => {
  return (
    <DialogActions>
      <Button onClick={onCancel}> cancel </Button>
      <Button onClick={onAccept} className="filled">
        save
      </Button>
    </DialogActions>
  );
};

type OwnProps = {
  handleAccept: (fromDate: Date | null, toDate: Date | null) => void;
  selectedFromDate: Date | null;
  selectedToDate: Date | null;
};

const SingleInputDateRangePicker: React.FC<OwnProps> = ({
  handleAccept,
  selectedFromDate,
  selectedToDate,
}) => {
  const minDate = dayjs().year(2000);

  const onCustomAccept = (value: DateRange<dayjs.Dayjs>) => {
    const [from, to] = value;
    const fromDate = from?.toDate() || null;
    const toDate = to?.toDate() || null;
    handleAccept(fromDate, toDate);
  };

  return (
    <Grid sx={styles.container}>
      <Typography sx={styles.label}>Date</Typography>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DateRangePicker
          slots={{
            field: SingleInputDateRangeField,
            actionBar: CustomActionBar,
            leftArrowIcon: ChevronIcon,
            rightArrowIcon: ChevronRightIcon,
          }}
          slotProps={{
            shortcuts: {
              items: shourtcutsItems,
            },
            textField: {
              InputProps: {
                endAdornment: (
                  <InputAdornment position="end">
                    <CalendarIcon />
                  </InputAdornment>
                ),
              },
              sx: styles.textfield,
            },
            popper: {
              sx: styles.popper,
              placement: window.innerHeight > 820 ? 'bottom-end' : 'auto',
            },
            actionBar: {
              actions: ['cancel', 'accept'],
            },
          }}
          minDate={minDate}
          disableFuture={true}
          closeOnSelect={false}
          onAccept={onCustomAccept}
          value={[dayjs(selectedFromDate), dayjs(selectedToDate)]}
          currentMonthCalendarPosition={2}
        />
      </LocalizationProvider>
    </Grid>
  );
};

export default SingleInputDateRangePicker;
